var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from '@angular/router';
import { AppConfigService } from '@app/app-config.service';
import { GIS_PORTAL_BASE, GIS_PORTAL_PATH } from '@app/modules/gis/gis-config';
import { hasValidGisToken, refreshGisToken, storeGisPortalConfig, startGisPkceFlow, getGisAuthRetryCount, clearGisAuthRetryCounter } from '@app/modules/gis/gis-token';
import * as i0 from "@angular/core";
import * as i1 from "../../../app-config.service";
import * as i2 from "@angular/router";
/**
 * Guards all protected routes to ensure a valid GIS Portal (gis.xom.cloud)
 * access token exists in sessionStorage before any route loads.
 *
 * Must be placed AFTER MsalGuard in canActivate so Azure AD auth completes first.
 *
 * PKCE flow (first visit):
 *  1. No token → generate verifier/challenge → store verifier in sessionStorage
 *     → redirect to Portal /authorize.
 *  2. Portal redirects back to origin/?code=AUTH_CODE.
 *  3. main.ts intercepts ?code= before Angular boots, exchanges it for tokens
 *     via POST /token, stores them in sessionStorage, restores the return URL.
 *  4. Guard fires again → token found → returns true → route loads.
 *
 * Subsequent visits: valid token in sessionStorage → returns true immediately.
 * On expiry: silent refresh token exchange; falls back to full PKCE if refresh fails.
 */
var GisAuthGuard = /** @class */ (function () {
    function GisAuthGuard(_appConfig, _router) {
        this._appConfig = _appConfig;
        this._router = _router;
    }
    GisAuthGuard.prototype.canActivate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var appConfig, config, currentRetryCount;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        appConfig = this._appConfig.getConfig();
                        config = appConfig && appConfig.arcgisConfig;
                        if (!config) {
                            console.error('GisAuthGuard: arcgisConfig missing from app-config.json');
                            return [2 /*return*/, true];
                        }
                        storeGisPortalConfig(GIS_PORTAL_BASE + GIS_PORTAL_PATH, config.appId);
                        if (hasValidGisToken()) {
                            clearGisAuthRetryCounter();
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, refreshGisToken()];
                    case 1:
                        if (_a.sent()) {
                            clearGisAuthRetryCounter();
                            return [2 /*return*/, true];
                        }
                        currentRetryCount = getGisAuthRetryCount();
                        if (currentRetryCount >= 3) {
                            console.error("GisAuthGuard: PKCE auth failed after 3 attempts, redirecting to error page");
                            this._router.navigate(['/gis-auth-error']);
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, startGisPkceFlow()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, false];
                }
            });
        });
    };
    GisAuthGuard.ngInjectableDef = i0.defineInjectable({ factory: function GisAuthGuard_Factory() { return new GisAuthGuard(i0.inject(i1.AppConfigService), i0.inject(i2.Router)); }, token: GisAuthGuard, providedIn: "root" });
    return GisAuthGuard;
}());
export { GisAuthGuard };
